export const menuItems = [
    {
        id: 1,
        label: "menuitems.menu.text",
        isTitle: true,
    },
    {
        id: 2,
        label: "menuitems.dashboards.text",
        icon: "bx-home-circle",
        link: "/dashboard",
    },
    {
        id: 3,
        label: "menuitems.company.text",
        icon: "bx-user-circle",
        link: "/companies",
    },
    {
        id: 4,
        label: "menuitems.user.text",
        icon: "bx-user",
        link: "/users",
    },
    {
        id: 5,
        label: "menuitems.activity.text",
        icon: "bx-align-left",
        link: "/activities",
    },
    {
        id: 6,
        label: "menuitems.history.text",
        icon: "bx-news",
        link: "/newsfeeds",
    },
    {
        id: 7,
        label: "menuitems.plans.text",
        icon: "bx-list-ul",
        link: "/plans",
    },
    {
        id: 8,
        label: "menuitems.subscription-history.text",
        icon: "bx-history",
        link: "/subscription-history",
    },
    {
        id: 9,
        label: "menuitems.posts-reports.text",
        icon: "bx-file",
        link: "/reports",
    },
    {
        id: 10,
        label: "menuitems.users-reports.text",
        icon: "bx-file",
        link: "/users-companies-reports",
    },
  
    
   
    
    
    
    
   
    
    
    
   
   
    
    
    
  
  
];

